import Persistable from "../../storage/persistable";

export default class Stream extends Persistable {
    constructor() {
        super();
        this.eventId = null;
        this.name = null;
        this.src = null;
        this.providerId = null;
        this.providerCode = null;
        this.isProviderSrcStale = false;
        this.markers = [];
    }

    toJSON() {
        return super.toJSON([], []);
    }
}
